const CACHE_CONFIG = {
    defaultCacheTime: 86400000,
    defaultStorage: 'sessionStorage'
};

function getCacheKey(config) {
    const method = config.method ? config.method.toUpperCase() : 'GET';
    const url = config.url || '';
    const params = config.params ? JSON.stringify(config.params) : '';
    return `cache_${method}_${url}_${params}`;
}

function getCacheData(key) {
    const storage = CACHE_CONFIG.defaultStorage;
    const cacheStr = window[storage].getItem(key);
    if(!cacheStr) return null;

    try {
        const cacheData = JSON.parse(cacheStr);
        if(cacheData.expireTime && Date.now() > cacheData.expireTime) {
            window[storage].removeItem(key);
            return null;
        }
        return cacheData.data;
    } catch (e) {
        return null;
    }
}

function setCacheData(key, data, cacheTime) {
    const storage = CACHE_CONFIG.defaultStorage;
    const expireTime = Date.now() + cacheTime;
    const cacheData = {
        data: data,
        expireTime: expireTime
    };
    window[storage].setItem(key, JSON.stringify(cacheData));
}

function getCache(config) {
    if(config.useCache && config.method && config.method.toLowerCase() === 'get') {
        const cacheKey = getCacheKey(config);
        const cachedData = getCacheData(cacheKey);
        if(cachedData) {
            return Promise.resolve(cachedData);
        }
        return null;
    }
    return null;
}

function setCache(config, response) {
    if(config.useCache && config.method && config.method.toLowerCase() === 'get') {
        if(response.msgCode == '1000' || response.msgCode == '4088') {
            const cacheKey = getCacheKey(config);
            const cacheTime = config.cacheTime || CACHE_CONFIG.defaultCacheTime;
            setCacheData(cacheKey, response, cacheTime);
        }
    }
}

export {
    CACHE_CONFIG,
    getCacheKey,
    getCacheData,
    setCacheData,
    getCache,
    setCache
};
